function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-instagram",
  "data-name": "Icon awesome-instagram",
  d: "M12,8.084a6.153,6.153,0,1,0,6.153,6.153A6.144,6.144,0,0,0,12,8.084Zm0,10.154a4,4,0,1,1,4-4,4.008,4.008,0,0,1-4,4ZM19.84,7.833A1.435,1.435,0,1,1,18.405,6.4,1.432,1.432,0,0,1,19.84,7.833Zm4.075,1.457a7.1,7.1,0,0,0-1.939-5.029,7.149,7.149,0,0,0-5.029-1.939c-1.981-.112-7.921-.112-9.9,0A7.139,7.139,0,0,0,2.018,4.255,7.126,7.126,0,0,0,.079,9.284c-.112,1.981-.112,7.921,0,9.9a7.1,7.1,0,0,0,1.939,5.029,7.158,7.158,0,0,0,5.029,1.939c1.981.112,7.921.112,9.9,0a7.1,7.1,0,0,0,5.029-1.939,7.149,7.149,0,0,0,1.939-5.029c.112-1.981.112-7.915,0-9.9Zm-2.56,12.023a4.05,4.05,0,0,1-2.281,2.281c-1.58.627-5.329.482-7.074.482s-5.5.139-7.074-.482a4.05,4.05,0,0,1-2.281-2.281c-.627-1.58-.482-5.329-.482-7.074s-.139-5.5.482-7.074A4.05,4.05,0,0,1,4.926,4.882C6.505,4.255,10.254,4.4,12,4.4s5.5-.139,7.074.482a4.05,4.05,0,0,1,2.281,2.281c.627,1.58.482,5.329.482,7.074S21.982,19.738,21.356,21.312Z",
  transform: "translate(0.005 -2.238)",
  fill: "#060608"
});

var SvgInst = function SvgInst(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.005,
    height: 24,
    viewBox: "0 0 24.005 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInst, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inst.ead1638c.svg";
export { ForwardRef as ReactComponent };